<!--
    Styles
-->

<style>


    /* main */

    #app > .l-header {
        position: relative;
        height: 42px;
        background: var(--cl-blue);
    }


    /* logo */

    #app > .l-header .logo {
        margin-left: 20px;
        margin-right: 48px;
    }
    #app > .l-header .logo svg {
        height: 20px;
    }


    /* nav */

    #app > .l-header .nav a {
        margin-right: 20px;
    }


    /* dropdown */

    #app > .l-header .ui-dropdown {
        height: 100%;
        min-width: 130px;
    }


    /* account */

    #app > .l-header .account {
        height: 100%;
        padding: 0 20px 0 12px;
        border-left: 1px solid var(--cl-blue-dark);
    }
    .l-header .account:hover,
    #app > .l-header .account.active {
        background: var(--cl-blue-dark);
    }
    #app > .l-header .account svg {
        width: 16px;
        height: 16px;
        transform: scale(0.75);
    }
    #app > .l-header .account p {
        margin-left: 8px;
        margin-right: 10px;
        flex-basis: auto; /* IE */
    }
    #app > .l-header .account img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }


    /* menu */

    #app > .l-header .menu {
        padding: 8px 0;
        border-radius: 0 0 0 3px;
        background: var(--cl-blue);
        border-top: 1px solid var(--cl-blue-dark);
    }
    #app > .l-header .menu a {
        padding: 8px 12px;
    }
    #app > .l-header .menu a:hover {
        background: var(--cl-blue-dark);
    }
    #app > .l-header .menu a svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }


</style>



<!--
    Template
-->

<template>
    <header class="l-header u-row cl-white">


        <!-- logo -->

        <router-link class="logo" to="/">
            <icon-logo />
        </router-link>


        <!-- nav -->

        <div class="nav u-flex u-row">
            <router-link :to="{name: 'dashboard', query: $route.query}" :class="{'w5 cl-yellow': $route.name === 'dashboard'}">レポート</router-link>
            <router-link :to="{name: 'deals', query: $route.query}" :class="{'w5 cl-yellow': $route.name === 'deals'}">物件データ</router-link>
        </div>


        <!-- user -->

        <ui-dropdown v-slot="{active, toggle}" v-if="account">

            <a class="account u-row" @click="toggle">
                <icon-dropdown />
                <p class="u-flex">{{ account.personal.fullname }}</p>
                <img class="u-fr" src="/images/avatar.png">
            </a>

            <div class="menu" v-show="active">
                <a class="u-row" :href="settings">
                    <icon-settings />
                    <span>設定</span>
                </a>
                <a class="u-row" @click="destroy()">
                    <icon-logout />
                    <span>ログアウト</span>
                </a>
            </div>

        </ui-dropdown>


    </header>
</template>



<!--
    Scripts
-->

<script>


    import {mapState, mapActions} from 'vuex'
    import iconLogo from '@/assets/icons/logo.svg'
    import iconDropdown from '@/assets/icons/dropdown.svg'
    import iconSettings from '@/assets/icons/settings.svg'
    import iconLogout from '@/assets/icons/logout.svg'
    import uiDropdown from '@/components/shared/ui/dropdown.vue'


    export default {

        components: {
            iconLogo,
            iconDropdown,
            iconSettings,
            iconLogout,
            uiDropdown
        },

        data () {
            return {
                settings: AUTH_ORIGIN + '/account' + '?app_id=' + APP_ID,
            }
        },

        computed: {
            ...mapState('session', [
                'account'
            ])
        },

        methods: {
            ...mapActions('session', [
                'destroy'
            ]),
        }

    }

</script>
